import VideoExamine from '../views/videoManagement/videoExamine'
import VideoList from '../views/videoManagement/videoList'
import MediaVideo from '../views/videoManagement/videoList/mediaIndex.vue'
// import PushList from '../views/videoManagement/pushList'
// import CityList from '../views/videoManagement/cityList'
import TagList from '../views/videoManagement/tagList'
import CommentList from '../views/videoManagement/commentList'
// import VideoHot from '../views/videoManagement/videoHot'
// import HotCity from '../views/videoManagement/hotCity'
// import FilterManagement from '../views/videoManagement/filterManagement'
// import RecommendSignature from '../views/videoManagement/recommendSignature'
// import FreeVidCfg from '../views/videoManagement/freeVidCfg'
import ModuleCfg from '../views/videoManagement/moduleCfg'

import Main from '../views/main'

const VideoRouter = {
  path: '/video-examine',
  component: Main,
  title: '视频帖子',
  icon: 'el-icon-video-camera-solid',
  meta: { keepAlive: false },
  children: [
    {
      path: '/video-examine',
      component: VideoExamine,
      name: 'videoExamine',
      title: '帖子审核',
      meta: { title: '帖子审核' ,keepAlive:true}
    },
    {
      path: '/video-list/1',
      component: VideoList,
      name: 'videoList',
      title: '帖子列表',
      meta: { title: '帖子列表' ,keepAlive:true}
    },
    // {
    //   path: '/video-list/2',
    //   component: VideoList,
    //   name: 'videoList',
    //   title: '图文帖子列表',
    //   meta: { title: '图文帖子列表' ,keepAlive:true}
    // },
    // {
    //   path: '/video-list/6',
    //   component: VideoList,
    //   name: 'videoList',
    //   title: '短视频列表',
    //   meta: { title: '短视频列表' ,keepAlive:true}
    // },
    // {
    //   path: '/video-list/3',
    //   component: VideoList,
    //   name: 'videoList',
    //   title: '图集列表',
    //   meta: { title: '图集列表' ,keepAlive:true}
    // },
    {
      path: '/video-list/media-video',
      component: MediaVideo,
      name: 'mediaVideo',
      title: '媒体库视频',
      meta: { title: '媒体库视频' ,keepAlive:true}
    },
    {
      path: '/module-cfg',
      component: ModuleCfg,
      name: 'moduleCfg',
      title: '模块配置',
      meta: { title: '模块配置' ,keepAlive:true}
    },
    {
      path: '/comment-list',
      component: CommentList,
      name: 'commentList',
      title: '评论管理',
      meta: { title: '评论管理' ,keepAlive:true}
    },
    // 推送列表
    // {
    //   path: '/push-list',
    //   component: PushList,
    //   name: 'pushList',
    //   title: '推送列表',
    //   meta: { title: '推送列表' ,keepAlive:true}
    // },
    {
      path: '/tag-list',
      component: TagList,
      name: 'tagList',
      title: '标签管理',
      meta: { title: '标签管理' ,keepAlive:true}
    },
    // {
    //   path: '/city-list',
    //   component: CityList,
    //   name: 'cityList',
    //   title: '城市列表',
    //   meta: { title: '城市列表' ,keepAlive:true}
    // },
    // {
    //   path: '/hot-city',
    //   component: HotCity,
    //   name: 'hotCity',
    //   title: '热门城市',
    //   meta: { title: '热门城市' ,keepAlive:true}
    // },
    // {
    //   path: '/video-hot',
    //   component: VideoHot,
    //   name: 'videoHot',
    //   title: '短视频最热',
    //   meta: { title: '短视频最热' ,keepAlive:true}
    // },
    // {
    //   path: '/filter-management',
    //   component: FilterManagement,
    //   name: 'filterManagement',
    //   title: '过滤词管理',
    //   meta: { title: '过滤词管理' ,keepAlive:true}
    // },
    // {
    //   path: '/recommend-signature',
    //   component: RecommendSignature,
    //   name: 'recommendSignature',
    //   title: '推荐标签',
    //   meta: { title: '推荐标签' ,keepAlive:true}
    // },
    // {
    //   path: '/free-vid-cfg',
    //   component: FreeVidCfg,
    //   name: 'freeVidCfg',
    //   title: '免费观看配置',
    //   meta: { title: '免费观看配置' ,keepAlive:true}
    // },
  ]
}

export default VideoRouter
